import {
  MobileOperatingSystem,
  getMobileOperatingSystem,
} from 'src/utils/get-mobile-operating-system';

export const IS_GOOGLE_PAY_AVAILABLE =
  getMobileOperatingSystem() === MobileOperatingSystem.ANDROID;

export const SHOW_GOOGLE_PAY_BUTTON = IS_GOOGLE_PAY_AVAILABLE;
